import React from 'react'
import './error.css'

const Error = () => {
  return (
    <div className='error_main'>
        <h1><span>404</span> - ERROR!</h1>
        <p>Page Couldn't Be Found</p>
    </div>
  )
}

export default Error